import React from 'react';

const multiRenderer = (props) => {
    const value = props?.value;
    return <>
        {
            Array.isArray(value) ?
                value.map((val, ind) => (
                    <span className={ind === 0 ? '' : 'ms-3'} onClick={(event) => {
                        event.preventDefault();
                        val?.onClick();
                    }}
                    style={{cursor: val?.onClick ? 'pointer': 'default'}}
                    >
                        <i className={val?.class} title={val?.title} />
                    </span>
                ))
                : <>{value}</>
        }
    </>


}

export default multiRenderer;
